var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSquare01SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24997 4C2.24997 3.0335 3.03347 2.25 3.99997 2.25H9.49997C10.4665 2.25 11.25 3.0335 11.25 4V9.5C11.25 10.4665 10.4665 11.25 9.49997 11.25H3.99997C3.03347 11.25 2.24997 10.4665 2.24997 9.5V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4C12.75 3.0335 13.5335 2.25 14.5 2.25H20C20.9665 2.25 21.75 3.0335 21.75 4V9.5C21.75 10.4665 20.9665 11.25 20 11.25H14.5C13.5335 11.25 12.75 10.4665 12.75 9.5V4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24997 14.5C2.24997 13.5335 3.03347 12.75 3.99997 12.75H9.49997C10.4665 12.75 11.25 13.5335 11.25 14.5V20C11.25 20.9665 10.4665 21.75 9.49997 21.75H3.99997C3.03347 21.75 2.24997 20.9665 2.24997 20V14.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.5C12.75 13.5335 13.5335 12.75 14.5 12.75H20C20.9665 12.75 21.75 13.5335 21.75 14.5V20C21.75 20.9665 20.9665 21.75 20 21.75H14.5C13.5335 21.75 12.75 20.9665 12.75 20V14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSquare01SolidStandard);
export default __webpack_public_path__ + "static/media/dashboard-square-01-solid-standard.a3b64b8dce700824dbc758fdac1bed23.svg";
export { ForwardRef as ReactComponent };